import React, { useContext } from 'react';

import IconGrab from '../svg/IconGrab';

import { DragContext } from '../../../contexts/drag-context';

function DragIcon() {
  const { dragRef } = useContext(DragContext);
  return (
    <IconGrab refGrab={dragRef} />
  );
}

export default DragIcon;
